import { Grid } from "@mui/material";
import { addAlert, useMaterialUIController } from "context";

export const CopyableId = ({
  id,
  title,
  isAdmin,
}: {
  id: string;
  title?: string;
  isAdmin?: boolean;
}) => {
  const [controller, dispatch] = useMaterialUIController();

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    addAlert(dispatch, "Copied to clipboard");
  };

  return (
    <Grid
      onClick={isAdmin ? () => copyToClipboard(id) : undefined}
      style={{ cursor: isAdmin ? "pointer" : "default" }}>
      {title}: ...{id?.substring(24)}
    </Grid>
  );
};
